import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

const flexCenter = `
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`

export const Info = styled.div`
    ${flexCenter}
    padding: 0 1.4rem 1.4rem 1.4rem;
    gap: 1rem;
`

export const Form = styled.form`
    ${flexCenter}
    padding: 1.4rem 0;
    flex-grow: 1;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
`

export const ContainerButton = styled.div`
    padding: 0 1.4rem 1.4rem;
    width: 100%;
`

export const CustomButton = styled(ButtonMui)`
    width: 100%;    
    height: 2.8rem !important;
    margin: 0 !important;
`
